import React, { useMemo, useEffect, useRef } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import DataGridPremiumUI from '../../Interface/DatagridPremmium/DataGridPremiumUI';
import { DataGridIdentifiers } from '../../Interface';
import dayjs from 'dayjs';

const AlertMessage = ({ selectedValuesState }) => {
  const { selectedValues } = selectedValuesState;

  const apiRef = useRef(null);

  const columns = useMemo(() => {
    const parsed = JSON.parse(selectedValues.columns) || [];
    return parsed.map((col) => ({
      flex: 1,
      ...col,
    }));
  }, [selectedValues.columns]);

  const rows = useMemo(() => {
    return (JSON.parse(selectedValues.content) || []).map((row) => ({
      ...row,
      id: uuidv4(),
    }));
  }, [selectedValues.content]);

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Paper elevation={1} sx={{ overflow: 'hidden', borderRadius: { xs: 1, sm: 2 } }}>
        <Typography variant="body2" fontWeight={600} fontSize="1rem" my={1}>
          {selectedValues.alert.name} - {dayjs(selectedValues.createdAt).format('YYYY.MM.DD HH:mm')}
        </Typography>

        <DataGridPremiumUI
          apiRef={apiRef}
          datagridIdentifier={DataGridIdentifiers.AlertMsg}
          height={550}
          columns={columns}
          rows={rows}
          rowCount={rows.length}
          getRowHeight={() => 'auto'}
          headerFilters={false}
          disableSave
          //disableVirtualization
        />
      </Paper>
    </Box>
  );
};

export default AlertMessage;
